/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Utility_New_HintInputs */

const cs_blog_utility_new_hint = /** @type {(inputs: Blog_Utility_New_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív pište česky, pak přeložte pomocí AI.`)
};

const en_blog_utility_new_hint = /** @type {(inputs: Blog_Utility_New_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft in Czech first, then translate with AI.`)
};

/**
* | output |
* | --- |
* | "Draft in Czech first, then translate with AI." |
*
* @param {Blog_Utility_New_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_utility_new_hint = /** @type {((inputs?: Blog_Utility_New_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Utility_New_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_utility_new_hint(inputs)
	return cs_blog_utility_new_hint(inputs)
});